import {Component, ContentChild, EventEmitter, Input, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'met-edit-operator-field',
  templateUrl: './edit-operator-field.component.html',
  styleUrls: ['./edit-operator-field.component.scss']
})
export class EditOperatorFieldComponent {
  @Input()
  fieldName: string = '';

  @Input()
  operatorValue: string = '';

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  @ContentChild('control') controlTpl?: TemplateRef<any>;

  constructor() {
  }

  setValue = (val: string) => {
    this.operatorValue = val ?? '';
    this.valueChange.emit(this.operatorValue);
  };

  changeValue() {
    this.valueChange.emit(this.operatorValue)
  }
}
